import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Gallery() {
  const [images, setImages] = useState([]);
  useEffect(() => {
    document.title = "Gallery — Manasvi Dental Clinic, Kota";
    api.get("/gallery").then(r => setImages(r.data)).catch(() => {});
  }, []);

  return (
    <div className="anim-fade-up">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-8">
        <span className="text-xs uppercase tracking-[0.25em] text-primary">Gallery</span>
        <h1 className="font-serif text-5xl sm:text-6xl tracking-tight mt-3 max-w-3xl">A quiet, modern place — designed for your comfort.</h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {images.map((img, i) => (
            <div key={img.id} className={`rounded-2xl overflow-hidden border border-border group ${i === 0 || i === 3 ? 'md:col-span-2 md:row-span-2' : ''}`} data-testid={`gallery-item-${i}`}>
              <div className="relative aspect-square">
                <img src={img.url} alt={img.caption} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                {img.caption && (
                  <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-foreground/70 to-transparent text-background text-sm">
                    {img.caption}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
